import angular from 'angular'

import fields from './fields.resource'
import icons from './icons.resource'
import labels from './labels.resource'
import constants from './constants.resource'
import logs from './logs.resource'
import paths from './paths.resource'
import types from './types.resource'

const name = 'globalResources'

angular.module(name, [])
  .factory('fields', fields)
  .factory('icons', icons)
  .factory('labels', labels)
  .factory('constants', constants)
  .factory('logs', logs)
  .factory('paths', paths)
  .factory('types', types)

export default name



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/resources/resources.module.js